import { FableticsLoyaltyRewardProgressBuilderComponent } from '~/techstyle-shared/react-builder-models';

export const BuilderLoyaltyRewardProgressConfig = {
  ...FableticsLoyaltyRewardProgressBuilderComponent,
  friendlyName: '_LoyaltyRewardProgress_ (Deprecated)',
};
